import type { ReactNode } from 'react';

export function WbLogo() {
  return <img className="wb-logo" src="/logo.png" alt="White Bot" />;
}

export function Panel({ title, right, children, className = '' }: { title?: string; right?: ReactNode; children: ReactNode; className?: string }) {
  return (
    <section className={`panel ${className}`}>
      {(title || right) && (
        <div className="panel-head">
          {title ? <h2>{title}</h2> : <span />}
          {right}
        </div>
      )}
      {children}
    </section>
  );
}

export function StatusPill({ kind, children }: { kind?: 'ok' | 'bad' | ''; children: ReactNode }) {
  return <span className={`status-pill ${kind ?? ''}`}>{children}</span>;
}

export function Metric({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className="metric">
      <strong>{label}</strong>
      <span>{children}</span>
    </div>
  );
}

export function EmptyState({ children }: { children: ReactNode }) {
  return <div className="empty-state">{children}</div>;
}

export function ErrorText({ error }: { error: unknown }) {
  return <p className="error">{formatError(error)}</p>;
}

export function formatError(error: unknown): string {
  if (error instanceof Error) return error.message;
  if (typeof error === 'string') return error;
  if (error && typeof error === 'object') {
    const record = error as Record<string, unknown>;
    const message = record.message || record.error_description || record.details || record.code;
    if (message) return String(message);
    try {
      return JSON.stringify(error);
    } catch {
      return 'Error desconocido';
    }
  }
  return String(error);
}
